import { Select as InnerSelect, SelectOption } from './select';
const Select = InnerSelect;
Select.Option = SelectOption;
export default Select;
